import styled from '@emotion/styled';
import { Flex } from 'lib/components/Flex';

export const Col = styled.div`
    flex: 1;
    text-align: left;
    display: flex;
    flex-direction: column;
    white-space: nowrap;
`;

export const Content = styled.div`
    width: 420px;
`;

export const PaddedRow = styled(Flex)`
    padding: 8px;
    width: 100%;

    ${Col}+${Col}{
        margin-left: 10px;
    };
`;
